// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2CQRF","name":"Header_name__3QUE-","birthday":"Header_birthday__SNmac","skeleton":"Header_skeleton__EPSTW"};